import { render } from "./ServicesSection.vue?vue&type=template&id=123f662c&scoped=true"
const script = {}

import "./ServicesSection.vue?vue&type=style&index=0&id=123f662c&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-123f662c"]])

export default __exports__